import styled from 'styled-components';

export const FileContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  .sheets {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 14px;

    .source-container {
      display: flex;
      align-items: center;
    }

    .sheet-item {
      display: flex;
      padding-left: 72px;
      position: relative;
      height: 24px;

      .line-2 {
        border-bottom: 1px solid #37ab6e;
        border-left: 1px solid #37ab6e;
        height: 25px;
        border-radius: 0 0 0 16px;
        width: 40%;
      }

      .line-5 {
        border-bottom: 1px solid #37ab6e;
        border-right: 1px solid #37ab6e;
        height: 25px;
        border-radius: 0 0 16px 0;
        width: 40%;
      }

      .line-4 {
        height: 1px;
        width: 24px;
        position: absolute;
        right: -24px;
        top: 55%;
        background: #d1d5db;
        z-index: 9;
      }

      button {
        padding: 0;
      }

      .sheet-wrapper {
        color: #5c5d61;
        width: 100%;
        margin-top: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 0;

        .control {
          display: flex;
          align-items: center;
          gap: 8px;

          .icon {
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;

            font-size: 20px;
            color: #c1c2c5;
          }

          .select {
            display: flex;
            align-items: center;
            gap: 8px;

            .select-item {
              width: 220px;
            }
          }
        }
      }
    }

    .missing-sheet {
      padding-left: 0;
      cursor: pointer;

      .line-5 {
        border-bottom: 1px solid #f54f6b;
        border-right: 1px solid #f54f6b;
      }

      p {
        color: #f54f6b;
        display: flex;
        align-items: center;
        gap: 8px;
        height: 35.5px;
        justify-content: initial;
      }
    }
  }

  .plus-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    font-size: 20px;
    color: #c1c2c5;
  }
`;

export const MenuListStyle = styled.div`
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
  padding: 16px;
  width: auto;
  max-width: 334px;

  .menu-item {
    width: 186px;
    padding: 8px 12px;
    color: #2b313d;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    border-radius: 4px;
    svg {
      width: 20px;
      height: 20px;
    }

    &.delete {
      color: red;
    }

    &:hover {
      background: #edf0f5;
    }
  }
`;

export const FileCardStyle = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  width: 100%;
  .line {
    position: absolute;
    right: -24px;
    top: 50%;
    height: 1px;
    width: 24px;
    background-color: #d1d5db;
  }

  button {
    display: flex;
    padding: 0;
  }

  .file-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 24px;
    margin-left: 22px;

    button {
      display: flex;
      padding: 0;
      border: none;
    }

    .file-name {
      display: flex;
      align-items: center;
      gap: 8px;

      p {
        &:first-child {
          color: gray;
          font-size: 14px;
          font-weight: 500;
          width: 250px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        &.multi-upload {
          padding: 3.5px 16px;
          border-radius: 4px;
          background: #f8f9fa;
          color: #868e96;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
`;
